// extracted by mini-css-extract-plugin
export default {"wrapper":"ProductPage_wrapper__h-3iH"};